import React from 'react';

import { useIntl } from 'react-intl';

import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';

import { messages } from './messages';

export const AgentBuildTabIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return <AgentAvatar label={formatMessage(messages.rovoAgentIconLabel)} size="small" />;
};
